import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import style from './style.css'
import button from 'Styles/button.css'

export default function ShowAnswerButton (props) {
  const ebookLegacySplitStyle = props.legacyEbook ? style.legacyButtonStyle : ''
  if (props.browser.lessThan.medium || props.splitPane) {
    const splitPaneStyle = props.footerWidth ? style.splitContent : ''
    return (
      <button
        aria-label='Show answer'
        data-test-id="activityShowAnswerBtn"
        className={classnames('btn-cdl-secondary', style.buttonBase, ebookLegacySplitStyle, splitPaneStyle)}
        onClick={props.onClick}
        tabIndex="0"
      >
      Show
      </button>
    )
  } else {
    return (
      <button
        aria-label='Show answer'
        data-test-id="activityShowAnswerBtn"
        className={classnames('btn-cdl-secondary', style.buttonBase, ebookLegacySplitStyle)}
        onClick={props.onClick}
        tabIndex="0"
      >
        <div>Show answer</div>
        <div className={button.footerButtonSubtext}>(no points)</div>
      </button>
    )
  }
}

ShowAnswerButton.propTypes = {
  browser: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  splitPane: PropTypes.bool.isRequired,
  legacyEbook: PropTypes.bool,
  footerWidth: PropTypes.bool
}
